import { render, staticRenderFns } from "./ArticleManagementModal__Style#Drawer.vue?vue&type=template&id=5df9c121&scoped=true&"
import script from "./ArticleManagementModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./ArticleManagementModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./ArticleManagementModal__Style#Drawer.vue?vue&type=style&index=0&id=5df9c121&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df9c121",
  null
  
)

export default component.exports